import cx from 'classnames'
import React, {Component} from 'react'
import Types from '../../types'

import './styles.css'

// TODO(jong): kill link type, in favor of a Link component
class Select extends Component {
  static propTypes = {
    className: Types.string,
    onChange: Types.func,
    options: Types.array,
  }

  onChange = event => {
    this.props.onChange(event.target.value)
  }

  render() {
    const {options, className, placeholder, ...rest} = this.props
    return (
      <div className={cx('select', className)}>
        <select
          {...rest}
          onChange={this.onChange}
          className='select-menu'
        >
          {placeholder && <option value="" disabled>{placeholder}</option>}
          {options.map(option =>
            <option value={option.value} key={option.value}>
              {option.text}
            </option>
          )}
        </select>
        <i className='fa fa-caret-down select-caret' />
      </div>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Select/index.js